module.exports = __webpack_public_path__ + "static/media/feliciaeco.14f7e65a.png";